import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProblemSection = () => {
  const [selectedProblem, setSelectedProblem] = useState('lost-orders');

  const problems = [
    {
      id: 'lost-orders',
      title: 'Kayıp Siparişler',
      icon: 'AlertTriangle',
      description: 'Kağıt notlar kaybolur, siparişler karışır',
      cost: '₺850/ay',
      timeWaste: '2.5 saat/gün',
      details: `Geleneksel kağıt bazlı sipariş sistemleri günde ortalama 3-5 siparişin kaybolmasına neden olur.\n\nBu durum hem müşteri memnuniyetsizliğine hem de direkt gelir kaybına yol açar.\n\nDijital sistemle %100 sipariş takibi sağlanır.`
    },
    {
      id: 'inventory-chaos',
      title: 'Stok Karmaşası',
      icon: 'Package',
      description: 'Hangi ürün ne kadar kaldı bilinmiyor',
      cost: '₺1,200/ay',
      timeWaste: '1.8 saat/gün',
      details: `Manuel stok takibi fire oranını %15-20 artırır ve gereksiz alımlar yapar.\n\nOtomatik stok yönetimi ile fire oranı %5'e düşer.\n\nAkıllı sipariş önerileri ile maliyetler optimize edilir.`
    },
    {
      id: 'payment-delays',title: 'Ödeme Gecikmeleri',icon: 'CreditCard',description: 'Nakit hesapları karışır, tahsilat zorlaşır',cost: '₺650/ay',timeWaste: '3.2 saat/gün',
      details: `Manuel kasa işlemleri günlük ortalama ₺50-100 fark yaratır.\n\nDijital ödeme sistemleri ile %100 doğru hesaplama.\n\nOtomatik raporlama ile günlük kapanış 5 dakikaya düşer.`
    },
    {
      id: 'customer-complaints',title: 'Müşteri Şikayetleri',icon: 'MessageSquare',description: 'Yanlış siparişler, geç teslimatlar',cost: '₺400/ay',timeWaste: '1.5 saat/gün',
      details: `Yanlış siparişler müşteri kaybına ve tekrar hazırlama maliyetine neden olur.\n\nDijital sistem ile sipariş doğruluğu %98'e çıkar.\n\nMüşteri memnuniyeti %35 artar.`
    }
  ];

  const currentProblem = problems.find(p => p.id === selectedProblem);

  return (
    <section className="py-20 bg-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-red-500 to-orange-500"></div>
        <div className="absolute top-20 left-20 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-48 h-48 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-red-500/20 text-red-300 px-4 py-2 rounded-full mb-6">
            <Icon name="AlertCircle" size={16} />
            <span className="font-inter font-accent-medium text-sm">
              Günlük Yaşanan Sorunlar
            </span>
          </div>
          
          <h2 className="font-poppins font-heading-bold text-3xl md:text-4xl lg:text-5xl mb-6">
            Geleneksel İşletme{' '}
            <span className="text-red-400">Sorunları</span>
          </h2>
          
          <p className="font-open-sans font-body-normal text-xl text-gray-300 max-w-3xl mx-auto">
            Her gün yaşadığınız bu sorunlar işletmenizin büyümesini engelliyor ve maliyetlerinizi artırıyor
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Problem Selector */}
          <div className="space-y-6">
            <h3 className="font-poppins font-heading-semibold text-2xl mb-8">
              Hangi sorunla en çok karşılaşıyorsunuz?
            </h3>
            
            <div className="space-y-4">
              {problems.map((problem) => (
                <button
                  key={problem.id}
                  onClick={() => setSelectedProblem(problem.id)}
                  className={`w-full p-6 rounded-xl border-2 transition-all duration-300 text-left ${
                    selectedProblem === problem.id
                      ? 'border-primary bg-primary/10 shadow-lg'
                      : 'border-gray-700 bg-gray-800/50 hover:border-gray-600 hover:bg-gray-800'
                  }`}
                >
                  <div className="flex items-start space-x-4">
                    <div className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${
                      selectedProblem === problem.id
                        ? 'bg-primary text-white' :'bg-gray-700 text-gray-300'
                    }`}>
                      <Icon name={problem.icon} size={24} />
                    </div>
                    
                    <div className="flex-1">
                      <h4 className="font-poppins font-heading-semibold text-lg mb-2">
                        {problem.title}
                      </h4>
                      <p className="font-open-sans font-body-normal text-gray-300 mb-3">
                        {problem.description}
                      </p>
                      
                      <div className="flex items-center space-x-6">
                        <div className="flex items-center space-x-2">
                          <span className="font-inter font-accent-semibold text-sm text-red-400">
                            {problem.cost}
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <Icon name="Clock" size={16} className="text-yellow-400" />
                          <span className="font-inter font-accent-medium text-sm text-yellow-400">
                            {problem.timeWaste}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className={`flex-shrink-0 transition-transform duration-300 ${
                      selectedProblem === problem.id ? 'rotate-90' : ''
                    }`}>
                      <Icon name="ChevronRight" size={20} />
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Right Side - Problem Details */}
          <div className="bg-white text-gray-900 rounded-2xl p-8 shadow-2xl">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center">
                <Icon name={currentProblem.icon} size={32} className="text-red-600" />
              </div>
              <div>
                <h4 className="font-poppins font-heading-bold text-2xl text-gray-900">
                  {currentProblem.title}
                </h4>
                <p className="font-open-sans font-body-normal text-gray-600">
                  Detaylı analiz ve çözüm önerisi
                </p>
              </div>
            </div>

            {/* Cost Impact */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-red-50 p-4 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="TrendingDown" size={20} className="text-red-600" />
                  <span className="font-inter font-accent-semibold text-sm text-red-600">
                    Aylık Kayıp
                  </span>
                </div>
                <p className="font-poppins font-heading-bold text-2xl text-red-600">
                  {currentProblem.cost}
                </p>
              </div>
              
              <div className="bg-yellow-50 p-4 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Clock" size={20} className="text-yellow-600" />
                  <span className="font-inter font-accent-semibold text-sm text-yellow-600">
                    Günlük Zaman Kaybı
                  </span>
                </div>
                <p className="font-poppins font-heading-bold text-2xl text-yellow-600">
                  {currentProblem.timeWaste}
                </p>
              </div>
            </div>

            {/* Problem Details */}
            <div className="mb-8">
              <h5 className="font-poppins font-heading-semibold text-lg mb-4 text-gray-900">
                Sorunun Detayları:
              </h5>
              <div className="space-y-3">
                {currentProblem.details.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="font-open-sans font-body-normal text-gray-700 leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-200 pt-6">
              <Button
                variant="default"
                size="lg"
                onClick={() => {
                  const element = document.getElementById('cozumler');
                  if (element) {
                    const offsetTop = element.offsetTop - 80;
                    window.scrollTo({
                      top: offsetTop,
                      behavior: 'smooth'
                    });
                  }
                }}
                iconName="ArrowRight"
                iconPosition="right"
                className="w-full"
              >
                Bu Sorunu Nasıl Çözüyoruz?
              </Button>
            </div>
          </div>
        </div>

        {/* Bottom Stats */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-8 bg-white/10 backdrop-blur-sm rounded-2xl px-8 py-6">
            <div className="text-center">
              <p className="font-poppins font-heading-bold text-3xl text-white mb-1">
                ₺3,100
              </p>
              <p className="font-open-sans font-body-normal text-sm text-gray-300">
                Ortalama aylık kayıp
              </p>
            </div>
            <div className="w-px h-12 bg-white/20"></div>
            <div className="text-center">
              <p className="font-poppins font-heading-bold text-3xl text-white mb-1">
                9.0 saat
              </p>
              <p className="font-open-sans font-body-normal text-sm text-gray-300">
                Günlük zaman kaybı
              </p>
            </div>
            <div className="w-px h-12 bg-white/20"></div>
            <div className="text-center">
              <p className="font-poppins font-heading-bold text-3xl text-white mb-1">
                %68
              </p>
              <p className="font-open-sans font-body-normal text-sm text-gray-300">
                İşletme verimsizliği
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;